import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  fetchPromotions,
  createPromotion,
  updatePromotion,
  deletePromotion,
  type ListPromotionsQuery,
  type CreatePromotionPayload,
  type UpdatePromotionPayload,
} from '@/services/api/promotions.api';

export function usePromotions(query: ListPromotionsQuery, enabled = true) {
  return useQuery({
    queryKey: ['promotions', query],
    queryFn: () => fetchPromotions(query),
    staleTime: 30_000,
    enabled: enabled && !!query.propertyId,
  });
}

export function useCreatePromotion() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: CreatePromotionPayload) => createPromotion(payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['promotions'] });
    },
  });
}

export function useUpdatePromotion() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      payload,
    }: {
      id: string;
      payload: UpdatePromotionPayload;
    }) => updatePromotion(id, payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['promotions'] });
    },
  });
}

export function useDeletePromotion() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deletePromotion(id),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['promotions'] });
    },
  });
}
